import React, { useEffect } from 'react';
import { useAuth } from './oktaContext';
import { useNavigate } from 'react-router-dom';
import oktaAuth from './oktaService';
import appleLogo from './assets/applelogo.png';
import './LoginPage.css';


const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        // This processes the IDP-initiated flow and extracts the token
        await oktaAuth.handleLoginRedirect();

        // You can also check the token:
        const idToken = oktaAuth.getIdToken();
        const accessToken = oktaAuth.getAccessToken();

        if (idToken || accessToken) {
          console.log("Token found:", idToken || accessToken);
          navigate('/home'); // Redirect to your protected route after handling
        } else {
          console.error('No token found');
        }
      } catch (error) {
        console.error('Error during Okta authentication', error);
      }
    };

    checkAuthentication();
  }, [navigate]);

  return (
    <div className="login-container" style={{ display:"flex", justifyContent:"center", alignItems:"center", height: "100vh", backgroundColor: "#ececee"}}>
      <div className="header-container">
        <div className="header-login">
          <img src={appleLogo} alt="Apple Logo" className="logo" />
          <h2>Performance Operations Hub</h2>
        </div>
        <div className="login-body">
          <h2>Welcome back!</h2>
          <p>Please login with Okta</p>
          <button onClick={login}>LOGIN WITH OKTA</button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
